import {FormTestingRulesServiceInterface} from '@/src/features/functional-testing/core/rules-service.interface'
import {inject, injectable} from 'inversify'
import {
  FreeTimeSlot,
  GetFreeTimeByDateRequest,
  GetWeekRulesRequest,
  WeekRulesResponse,
} from '@/src/features/functional-testing/core/dto'
import {DI} from '@/src/config/di/types'
import {Routes} from '@/src/config/routes'
import type {IApiClientService} from '@/src/ports/services/api'

@injectable()
export class FunctionalTestingRulesService implements FormTestingRulesServiceInterface {
  @inject(DI.IApiClientService)
  client!: IApiClientService

  getWeekRules(params: GetWeekRulesRequest, customRouteFn?: (labId: Id) => string): Promise<WeekRulesResponse> {
    const route = customRouteFn ?? Routes.webApi.form.testing.shopRules

    return this.client.get(route(params.labId))
  }

  getTimeSlotsByLabOnDate(
    params: GetFreeTimeByDateRequest,
    customRouteFn?: (labId: Id) => string,
  ): Promise<FreeTimeSlot[]> {
    const route = customRouteFn ?? Routes.webApi.form.testing.shopTimeSlots

    return this.client.get(route(params.labId), {params: {date: params.date}})
  }
}
